import { useTranslation } from 'react-i18next';
import { useField } from 'formik';
import QuillDelta from 'quill-delta';

import styled from 'styled-components';
import { QuillInput } from '@treams/treams-ui';

const ErrorMessage = styled.p`
	color: ${(props) => props.theme.colors.danger};
	padding-top: 6px;
`;

export default function OpenQuestionInput(props: { name: string }) {
	const [field, { value, error }, { setValue }] = useField<QuillDelta>(props.name);
	const { t } = useTranslation();

	return (
		<>
			<QuillInput value={value} onChange={(value) => setValue(value)} />
			{error && (
				<ErrorMessage>
					{t('validation.mixed.required').replace('${path}', t(`common.fields.${field.name}`))}
				</ErrorMessage>
			)}
		</>
	);
}
